
import { Link } from 'react-router-dom';
import './Leaderboard.css';


const logoPath = "/images/gratiSphere.svg";
const Leaderboard = () => {



    return (
        <div className="leaderboard-container">
            <img src={logoPath} alt="GratiSphere Logo" className="gratitude-logo" />
            <h1 className="group-title">GratiSphere Leaderboard</h1>
            {/* Links to gratitude leaderboard */}
            <div className="leaderboard-links">
                <div><Link to="/gratitude-leaderboard" className="leaderboard-link">Leaderboard</Link></div>
            </div>
            <hr className="section-divider" />
            
            
            <img src="/images/weighlogo.png" alt="WeighForward Logo" className="weigh-logo" />
            <h1 className="group-title">WeighForward Leaderboards</h1>

 
            <div className="leaderboard-links">
                {/* Links to individual and group leaderboards */}
                <div><Link to="/individual-leaderboard" className="leaderboard-link">Individual Leaderboard</Link></div>
                <div><Link to="/group-leaderboard" className="leaderboard-link">Group Leaderboard</Link></div>

                {/* Coming Soon Message */}
                {/* <p className="coming-soon">Company Leaderboard coming soon.</p> */}
            </div>
        </div>
    );
};

export default Leaderboard;
